export default {
  "content": "<path d=\"M16.25 11.875V9.687a2.813 2.813 0 00-2.813-2.812h-1.25a.937.937 0 01-.937-.938v-1.25a2.813 2.813 0 00-2.813-2.812H6.875m.625 10l2.5 2.5m0 0l2.5-2.5m-2.5 2.5v-5m-1.25-7.5H4.687a.937.937 0 00-.937.938v14.374c0 .518.42.938.938.938h10.625c.517 0 .937-.42.937-.938V9.375a7.5 7.5 0 00-7.5-7.5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};